import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getExportHistory = createAsyncThunk(
  "reportExport/getExportHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          params.append(key, value);
        }
      });
      const { data } = await axios.get(`${API_URL.REPORT_EXPORT.HISTORY}?${params.toString()}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getExportStatus = createAsyncThunk(
  "reportExport/getExportStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_URL.REPORT_EXPORT.STATUS(payload));
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const initialState = {
  exportHistory: { list: [], total_records: 0 },
};

const reportExportSlice = createSlice({
  name: "reportExport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExportHistory.fulfilled, (state, action) => {
        state.exportHistory.list = action.payload?.data?.list || [];
        state.exportHistory.total_records = action.payload?.data?.totalRecords || 0;
      });
  },
});

export default reportExportSlice.reducer;
